<script>

    import { toast } from 'bulma-toast'
    import { pricesStore, priceStore, modalStore } from '../stores'

    import PricesService from '../$services/prices.service'

    import Button from '../$components/button.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Providers from '../$components/providers.svelte'
    import Select from '../$components/select.svelte'
    import Date from '../$components/date.svelte'
    import Form from '../$components/form.svelte'

    let loading = false
    let data = {
        provider: $priceStore.provider,
        service: $priceStore.service,
        pricing: $priceStore.pricing,
        value: $priceStore.value,
        volumetricMin: $priceStore.volumetricMin,
        volumetricMax: $priceStore.volumetricMax,
        expired: $priceStore.expired,
    }

    async function updatePrice() {

        loading = true
        const resp = await PricesService.updatePrice($priceStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        pricesStore.replace(resp.data)
        modalStore.close()
    }

</script>

<Form on:submit={updatePrice} { loading } >
    <div class="columns">
        <div class="column">
            <Providers bind:provider={data.provider} bind:service={data.service} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Select
                bind:value={data.pricing}
                label="Pricing"
                options={[
                    {value: 'price', text: 'Precio'},
                    {value: 'percent', text: 'Porcentaje'},
                    {value: 'amount', text: 'Monto'},
                ]}
            />
        </div>
        <div class="column">
            <InputNumber bind:value={data.value} label="Valor" placeholder="Valor" />
        </div>
    </div>
    {#if $priceStore.type === 'user'}
        <div class="columns">
            <div class="column">
                <Date bind:value={data.expired} label="Fecha de expiración" />
            </div>
        </div>
    {/if}
    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Guardar" icon="save" color="primary" {loading} />
        </div>
    </div>
</Form>